import { Colors } from '../../../../utils/resources/colors';
import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export interface ListToneCSSStyle extends CRBTUICSSStyle
{
    getTitleCSSStyle():object;
    getMobileTitleCSSStyle():object;
    getCarouselDivCSSStyle():object;
}

export class ListToneCSSStyleImpl extends CRBTUICSSStyleImpl implements ListToneCSSStyle
{
   
    getCarouselDivCSSStyle():object
    {
        return{
            marginLeft: "0px", marginRight: "0px"
        };
    }
    getMobileTitleCSSStyle(): object {
        return {
            display: "flex",
            textAlign: "center",
            justifyContent: 'flex-start',
            // height: "30px",
            fontWeight: 900,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            // fontSize: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "16px" : "14px",
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "30px",
            marginBottom: '15px',
            marginTop: '0px',  
            marginLeft: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '30px' : "15px",
        };
    }
    getTitleCSSStyle(): object 
    {
        return {
            // display: "flex",
            textAlign: "center",
            justifyContent: 'flex-start',
            // height: "30px",
            fontWeight: 900,
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            // fontSize: this.getResources().getFont(Fonts.h14),
            color: this.getResources().getColor(Colors.color_6),
            fontFamily: this.getResources().getFontFamily(),
            // lineHeight: "30px",
            // marginBottom: '30px',
            // marginTop: '10px',  
            // marginLeft: '0px',
        };
    } 

}    


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/listtonecss.tsx